export const HEALTH_REPORT_ROLES = ["owner", "project_manager"];

export const canAccessHealthReport = (role) =>
  HEALTH_REPORT_ROLES.includes(role);
